module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "article-list-item padded-container"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "article-ref small-6 column"
  }, [_c('strong', [_vm._v(_vm._s(_vm.articleName))]), _c('br'), _vm._v(" "), _c('em', [_vm._v(_vm._s(_vm.$t('order.label.item.reference')) + " " + _vm._s(_vm.articleRef))])]), _vm._v(" "), _c('div', {
    staticClass: "small-6 column"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "float-right"
  }, [_c('status-chips', {
    attrs: {
      "status": _vm.articleStatus
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "delivery-flags float-right"
  }, [(_vm.deliveryDateHasChanged) ? _c('ui-icon', {
    staticClass: "notif-warning-color",
    attrs: {
      "icon": "warning"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.deliveryDateIsDifferent) ? _c('ui-icon', {
    staticClass: "notif-info-color",
    attrs: {
      "icon": "info"
    }
  }) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row lateral-sub-padding"
  }, [_c('div', {
    staticClass: "small-5 medium-3 large-2 column"
  }, [_vm._v(_vm._s(_vm.$t('order.label.item.ordered-qty')))]), _vm._v(" "), _c('div', {
    staticClass: "small-7 medium-9 large-10 column"
  }, [_c('strong', [_vm._v(_vm._s(_vm.articleOrderedQty))])])]), _vm._v(" "), _c('div', {
    staticClass: "row delivery-date lateral-sub-padding"
  }, [_c('div', {
    staticClass: "small-5 medium-3 large-2 column"
  }, [_vm._v(_vm._s(_vm.$t('order.label.estimed-delivery-date')))]), _vm._v(" "), _c('div', {
    staticClass: "small-7 medium-9 large-10 column",
    class: {
      'notif-warning-color': _vm.deliveryDateHasChanged, 'notif-info-color': _vm.deliveryDateIsDifferent
    }
  }, [_c('div', [_c('strong', [_c('span', [_vm._v("le " + _vm._s(_vm.formatDate(_vm.deliveryDate)))])])]), _vm._v(" "), (_vm.deliveryDateIsDifferent || _vm.deliveryDateHasChanged) ? _c('div', {
    staticClass: "delivery-messages"
  }, [(_vm.deliveryDateHasChanged) ? _c('div', {
    staticClass: "notif-warning-color"
  }, [_vm._v(_vm._s(_vm.$t('order.label.estimed-delivery-date-has-changed')))]) : _vm._e(), _vm._v(" "), (_vm.deliveryDateIsDifferent) ? _c('div', {
    staticClass: "notif-info-color"
  }, [_vm._v(_vm._s(_vm.$t('order.label.estimed-delivery-date-is-different')))]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row lateral-sub-padding"
  }, [_c('div', {
    staticClass: "small-5 medium-3 large-2 column"
  }, [_vm._v(_vm._s(_vm.$t('order.label.item.comment')))]), _vm._v(" "), _c('div', {
    staticClass: "small-7 medium-9 large-10 column"
  }, [_c('strong', [_vm._v(_vm._s(_vm.articleNote))])])]), _vm._v(" "), _c('div', {
    staticClass: "lateral-sub-padding"
  }, [(_vm.articleShippedQty > 0) ? _c('tracking-list', {
    attrs: {
      "tracking-items": _vm.deliveryTracking,
      "article-ordered-qty": _vm.articleOrderedQty,
      "article-shipped-qty": _vm.articleShippedQty
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.articleStatus == 'in-progress' && !_vm.hasDeliveryTracking) ? _c('div', {
    staticClass: "row lateral-sub-padding"
  }, [_c('div', {
    staticClass: "small-5 medium-3 large-2 column"
  }, [_vm._v(_vm._s(_vm.$t('order.label.item.tracking.shipped-qty')))]), _vm._v(" "), _c('div', {
    staticClass: "small-7 medium-9 large-10 column"
  }, [_c('strong', [_vm._v(_vm._s(_vm.articleShippedQty))])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-32f8546c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArticleListItem.vue
// module id = 295
// module chunks = 2